export function focusInputGroups(query = document.querySelectorAll('.inputGroup input, .inputGroup select, .inputGroup textarea')) {
    for (const input of query) {
        if (input.dataset.focusInputInit === 'true') continue;
        input.dataset.focusInputInit = 'true';

        const inputGroup = input.closest(".inputGroup");
        const infieldInputGroup = input.closest(".infieldInputGroup");

        checkFilledInput(input);

        input.addEventListener("focus", () => {
            if (inputGroup) inputGroup.classList.add("is-focus");
            if (infieldInputGroup) infieldInputGroup.classList.add("is-focus");
        });

        input.addEventListener("blur", () => {
            if (inputGroup) inputGroup.classList.remove("is-focus");
            if (infieldInputGroup) infieldInputGroup.classList.remove("is-focus");
        });

        input.addEventListener("input", () => checkFilledInput(input));

        if (input.id === 'input_phone' && input.dataset.phoneSanitizeInit !== 'true') {
            input.dataset.phoneSanitizeInit = 'true';

            const sanitize = () => {
                if (input.value.includes('+')) {
                    input.value = input.value.replace(/\+/g, '');
                }
            };

            input.addEventListener('input', sanitize);
            input.addEventListener('paste', () => requestAnimationFrame(sanitize));
        }
    }
}

new MutationObserver(() => {
    focusInputGroups();
}).observe(document.body, { childList: true, subtree: true });

export function checkFilledInput(input) {
    const inputGroup = input.closest(".inputGroup");
    const infieldInputGroup = input.closest(".infieldInputGroup");

    const updateInputClasses = () => {
        const val = input.value?.trim() ?? "";
        const isAutofill = input.matches?.(":-webkit-autofill") || false;
        const isFilled = val !== "" || isAutofill;

        if (inputGroup) inputGroup.classList.toggle("is-filled", isFilled);
        if (infieldInputGroup) infieldInputGroup.classList.toggle("is-filled", isFilled);

        if (input.dataset.intlTelInputId !== undefined) {
            if (inputGroup) inputGroup.classList.add("is-focus");
            if (infieldInputGroup) infieldInputGroup.classList.add("is-focus");

            setTimeout(() => {
                if (document.activeElement !== input) {
                    if (inputGroup) inputGroup.classList.remove("is-focus");
                    if (infieldInputGroup) infieldInputGroup.classList.remove("is-focus");
                }
            }, 0);
        }
    };

    updateInputClasses();

    const observer = new MutationObserver(updateInputClasses);
    observer.observe(input, { attributes: true, attributeFilter: ['class', 'autofill'] });

    const intervalId = setInterval(updateInputClasses, 200);
    input.addEventListener('focus', updateInputClasses);

    setTimeout(() => {
        clearInterval(intervalId);
        observer.disconnect();
        input.removeEventListener('focus', updateInputClasses);
    }, 5000);

    return () => {
        clearInterval(intervalId);
        observer.disconnect();
        input.removeEventListener('focus', updateInputClasses);
    };
}
